import * as PIXI from 'pixi.js'
import * as UI from './gameUI.js'
import { pixiApp } from './initializePixi.js'
import Matter from 'matter-js'

// fps calculation
let startTime = performance.now()
const lastTime = 0
let frameCount = 0
let totalFrameCount = 0
let totalTimeElapsed = 0
let averageFPS = 0

let pixiTickerRun = false
let MaxFps = 0
const setTickerRun = (value) => { pixiTickerRun = value }

let tickerCallback = null

const startGameTicker = () => {
  if (!pixiApp?.app?.ticker) return

  MaxFps = pixiApp.app.ticker.FPS
  console.log('start Ticker')

  if (tickerCallback) {
    pixiApp.app.ticker.remove(tickerCallback)
    tickerCallback = null
  }

  tickerCallback = (delta) => {
    frameCount++
    totalFrameCount++

    const currentTime = performance.now()
    const elapsed = currentTime - startTime

    if (elapsed >= 1000) {
      totalTimeElapsed += elapsed
      averageFPS = Math.round((totalFrameCount * 1000) / totalTimeElapsed)

      frameCount = 0
      totalFrameCount = 0
      totalTimeElapsed = 0
      startTime = currentTime
    }

    if (UI.matterAssets?.engine) {
      Matter.Engine.update(UI.matterAssets.engine)
    }

    UI.assets.boxes.forEach(box => {
      if (box.boxContainer?.boxState) {
        box.boxContainer.boxState(delta)
      }
    })

    if (!pixiTickerRun) return

    UI.assets.activeBalls.forEach(ball => {
      if (ball.pixiBody && ball.matterBody?.position) {
        ball.pixiBody.position.set(ball.matterBody.position.x, ball.matterBody.position.y)
      }
    })
  }

  pixiApp.app.ticker.add(tickerCallback)
  pixiApp.app.ticker.start()
}

const stopGameTicker = () => {
  if (pixiApp?.app?.ticker) {
    if (tickerCallback) {
      pixiApp.app.ticker.remove(tickerCallback)
      tickerCallback = null
    }
    pixiApp.app.ticker.stop()
  }
}

export {
  setTickerRun,
  startGameTicker,
  stopGameTicker
}

export function getFPS () {
  return (averageFPS && averageFPS > 0) ? (60 / averageFPS) : 1
}
